import DeclineMeetingSelectionState from '../data/store/schema/DeclineMeetingSelectionState';
import { getEditorViewStateMessageContent, getEditorViewStateDeclineMeetingContent, getDeclineMeetingSelectedCategoryKey, } from '../selectors/getStoreProperties';
/**
 * Utility function to get decline meeting message
 * @returns decline meeting message from store
 */
export default function getDeclineMeetingMessage() {
    var selectedCategoryKey = getDeclineMeetingSelectedCategoryKey();
    if (selectedCategoryKey == null) {
        return getEditorViewStateMessageContent();
    }
    else {
        if (selectedCategoryKey == DeclineMeetingSelectionState.UseAutomaticReplyMessage) {
            return getEditorViewStateMessageContent();
        }
        else {
            return getEditorViewStateDeclineMeetingContent();
        }
    }
}
//# sourceMappingURL=getDeclineMeetingMessage.js.map